export const TRIPS_RESET_STATE = 'TRIPS_RESET_STATE';
export const TRIPS_CURRENT_ITEM = 'TRIPS_CURRENT_ITEM';

export const TRIPS_REQUEST_LOADING = 'TRIPS_REQUEST_LOADING';
export const TRIPS_REQUEST_SUCCESS = 'TRIPS_REQUEST_SUCCESS';
export const TRIPS_REQUEST_FAILED = 'TRIPS_REQUEST_FAILED';

export const TRIPS_CURRENT_ACTION = 'TRIPS_CURRENT_ACTION';
export const TRIPS_RESET_ACTION = 'TRIPS_RESET_ACTION';